export interface MediaItem {
  id: string;
  title: string;
  cover: string;
  category: "电影" | "电视剧" | "综艺";
  genre: string[];
  region: string;
  year: number;
  director: string;
  actors: string[];
  synopsis: string;
  rating: number;
  popularity: number;
  updateDate: string;
  tags: string[];
  featured?: boolean;
}

export const mediaList: MediaItem[] = [
  {
    id: "m001",
    title: "流浪地球",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20key%20art%2C%20a%20colossal%20planetary%20engine%20tower%20rising%20above%20a%20frozen%20snow%20covered%20earth%2C%20tiny%20astronaut%20silhouettes%2C%20deep%20navy%20blue%20and%20warm%20amber%20color%20grading%2C%20dramatic%20volumetric%20light%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20ultra%20detailed%20premium%20streaming%20poster%20illustration&width=600&height=900&seq=film-m001&orientation=portrait",
    category: "电影",
    genre: ["科幻", "冒险", "灾难"],
    region: "中国大陆",
    year: 2019,
    director: "郭帆",
    actors: ["吴京", "屈楚萧", "李光洁", "吴孟达"],
    synopsis:
      "太阳即将毁灭，人类在地球表面建造出巨大的推进器，试图带着地球逃离太阳系，寻找新的家园。在漫长的流浪旅程中，一群普通人挺身而出，为人类的存续拼尽全力。",
    rating: 8.6,
    popularity: 96,
    updateDate: "2024-09-18",
    tags: ["科幻大片", "家国情怀", "视觉奇观"],
    featured: true,
  },
  {
    id: "m002",
    title: "满江红",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20historical%20mystery%20key%20art%2C%20ancient%20Chinese%20courtyard%20at%20night%20with%20red%20lanterns%2C%20shadowy%20warrior%20in%20traditional%20dark%20armor%20holding%20a%20blade%2C%20deep%20crimson%20and%20navy%20tones%2C%20moody%20dramatic%20lighting%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20streaming%20poster%20illustration&width=600&height=900&seq=film-m002&orientation=portrait",
    category: "电影",
    genre: ["剧情", "悬疑", "古装"],
    region: "中国大陆",
    year: 2023,
    director: "张艺谋",
    actors: ["沈腾", "易烊千玺", "张译", "雷佳音"],
    synopsis:
      "南宋绍兴年间，一群身份各异的小人物被卷入一场错综复杂的迷局。在层层反转之中，他们用各自的方式守护着心中的家国大义。",
    rating: 8.1,
    popularity: 93,
    updateDate: "2024-08-22",
    tags: ["古装悬疑", "群像", "反转"],
    featured: true,
  },
  {
    id: "m003",
    title: "长安三万里",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20animated%20key%20art%2C%20a%20Tang%20dynasty%20poet%20standing%20on%20a%20cliff%20overlooking%20a%20vast%20moonlit%20mountain%20range%2C%20traditional%20ink%20painting%20atmosphere%2C%20deep%20blue%20and%20gold%20tones%2C%20epic%20composition%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20poster%20illustration&width=600&height=900&seq=film-m003&orientation=portrait",
    category: "电影",
    genre: ["动画", "剧情", "历史"],
    region: "中国大陆",
    year: 2023,
    director: "谢君伟 / 邹靖",
    actors: ["杨天翔", "凌振赫", "孙路路"],
    synopsis:
      "安史之乱后，高适回忆起自己与李白的一生过往。四十八首唐诗串起大唐由盛转衰的岁月，也勾勒出一段跨越半生的深厚情谊。",
    rating: 8.3,
    popularity: 91,
    updateDate: "2024-07-30",
    tags: ["国漫", "大唐", "诗与远方"],
    featured: true,
  },
  {
    id: "m004",
    title: "孤注一掷",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20key%20art%2C%20silhouette%20of%20a%20man%20in%20a%20dark%20hooded%20jacket%20against%20a%20wall%20of%20glowing%20digital%20screens%2C%20cold%20navy%20and%20toxic%20green%20accents%2C%20tense%20atmosphere%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20streaming%20poster%20illustration&width=600&height=900&seq=film-m004&orientation=portrait",
    category: "电影",
    genre: ["剧情", "犯罪", "惊悚"],
    region: "中国大陆",
    year: 2023,
    director: "申奥",
    actors: ["张艺兴", "金晨", "咏梅", "王传君"],
    synopsis:
      "程序员潘生被高薪招聘骗到境外，卷入一个庞大的网络诈骗集团。面对威逼利诱，他与同样被困的模特安娜携手，寻找一线生机。",
    rating: 7.9,
    popularity: 90,
    updateDate: "2024-09-05",
    tags: ["反诈", "现实题材", "犯罪"],
    featured: true,
  },
  {
    id: "m005",
    title: "封神第一部",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20fantasy%20epic%20key%20art%2C%20a%20legendary%20bronze%20armored%20warrior%20standing%20before%20an%20ancient%20mythical%20battlefield%2C%20fire%20and%20storm%2C%20deep%20navy%20and%20orange%20color%20grading%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20streaming%20poster%20illustration&width=600&height=900&seq=film-m005&orientation=portrait",
    category: "电影",
    genre: ["奇幻", "动作", "古装"],
    region: "中国大陆",
    year: 2023,
    director: "乌尔善",
    actors: ["费翔", "李雪健", "黄渤", "于适"],
    synopsis:
      "商王殷寿与狐妖妲己勾结，暴虐无道。质子姬发在一次次抉择中逐渐觉醒，踏上反抗暴君、追寻正道的史诗征程。",
    rating: 8.2,
    popularity: 89,
    updateDate: "2024-06-16",
    tags: ["神话史诗", "视效大片", "封神宇宙"],
  },
  {
    id: "m006",
    title: "消失的她",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20suspense%20key%20art%2C%20a%20lone%20woman%20silhouette%20on%20an%20empty%20tropical%20beach%20at%20dusk%2C%20dark%20stormy%20sea%2C%20deep%20blue%20and%20muted%20amber%20tones%2C%20eerie%20atmosphere%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20streaming%20poster%20illustration&width=600&height=900&seq=film-m006&orientation=portrait",
    category: "电影",
    genre: ["悬疑", "剧情", "犯罪"],
    region: "中国大陆",
    year: 2023,
    director: "崔睿",
    actors: ["朱一龙", "倪妮", "文咏珊", "杜江"],
    synopsis:
      "何非的妻子在结婚周年旅行中离奇消失，一名陌生女子却突然出现自称是他的妻子。随着调查深入，一桩精心设计的骗局逐渐浮出水面。",
    rating: 7.6,
    popularity: 88,
    updateDate: "2024-08-08",
    tags: ["悬疑反转", "东南亚", "烧脑"],
  },
  {
    id: "m007",
    title: "热烈",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sports%20comedy%20key%20art%2C%20young%20street%20dancer%20mid%20air%20under%20dramatic%20stage%20lights%2C%20vibrant%20orange%20and%20deep%20blue%20rim%20light%2C%20energetic%20motion%20blur%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20poster%20illustration&width=600&height=900&seq=film-m007&orientation=portrait",
    category: "电影",
    genre: ["喜剧", "运动", "剧情"],
    region: "中国大陆",
    year: 2023,
    director: "大鹏",
    actors: ["黄渤", "王一博", "刘敏涛", "岳云鹏"],
    synopsis:
      "凯文教练带着一群热爱街舞的年轻人，在一次次摔倒与重来中追逐登上更大舞台的梦想。热血、欢笑与坚持交织成这个夏天最热烈的记忆。",
    rating: 7.7,
    popularity: 82,
    updateDate: "2024-05-24",
    tags: ["街舞", "热血", "青春"],
  },
  {
    id: "m008",
    title: "第二十条",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20key%20art%2C%20a%20lone%20figure%20walking%20through%20a%20rain%20soaked%20city%20street%20at%20night%2C%20reflective%20wet%20pavement%2C%20deep%20navy%20and%20warm%20street%20lamp%20glow%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20streaming%20poster%20illustration&width=600&height=900&seq=film-m008&orientation=portrait",
    category: "电影",
    genre: ["剧情", "喜剧", "家庭"],
    region: "中国大陆",
    year: 2024,
    director: "张艺谋",
    actors: ["雷佳音", "马丽", "赵丽颖", "高叶"],
    synopsis:
      "一名普通检察官在处理一系列案件的过程中，不断追问法律与正义的边界。在情与法的纠葛里，他选择为普通人撑起一把伞。",
    rating: 7.8,
    popularity: 85,
    updateDate: "2024-09-12",
    tags: ["现实题材", "普法", "温情"],
  },
  {
    id: "m009",
    title: "狂飙",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20drama%20key%20art%2C%20two%20men%20facing%20each%20other%20in%20a%20dim%20police%20interrogation%20room%2C%20harsh%20overhead%20light%2C%20deep%20navy%20and%20amber%20tones%2C%20tense%20atmosphere%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20streaming%20poster%20illustration&width=600&height=900&seq=film-m009&orientation=portrait",
    category: "电视剧",
    genre: ["剧情", "犯罪", "悬疑"],
    region: "中国大陆",
    year: 2023,
    director: "徐纪周",
    actors: ["张译", "张颂文", "李一桐", "张志坚"],
    synopsis:
      "刑警安欣与鱼贩高启强相识于微时，二十年间，一个坚守底线，一个逐步坠入深渊。正义与罪恶的拉锯，写尽人性的复杂与时代的变迁。",
    rating: 9.1,
    popularity: 98,
    updateDate: "2024-09-20",
    tags: ["扫黑", "演技派", "年度爆款"],
    featured: true,
  },
  {
    id: "m010",
    title: "漫长的季节",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20drama%20key%20art%2C%20an%20old%20industrial%20steel%20mill%20in%20northern%20China%20under%20grey%20snow%2C%20a%20solitary%20man%20in%20a%20long%20coat%2C%20deep%20blue%20and%20rust%20tones%2C%20melancholic%20mood%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20streaming%20poster%20illustration&width=600&height=900&seq=film-m010&orientation=portrait",
    category: "电视剧",
    genre: ["悬疑", "剧情", "年代"],
    region: "中国大陆",
    year: 2023,
    director: "辛爽",
    actors: ["范伟", "秦昊", "陈明昊", "李庚希"],
    synopsis:
      "桦林小城的一桩碎尸案，牵动着出租车司机王响后半生的执念。十八年后，尘封的往事伴随着旧日旋律，缓缓揭开真相。",
    rating: 9.4,
    popularity: 94,
    updateDate: "2024-08-30",
    tags: ["东北", "年代质感", "高口碑"],
  },
  {
    id: "m011",
    title: "三体",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20series%20key%20art%2C%20a%20giant%20radio%20telescope%20dish%20under%20a%20starry%20night%20sky%2C%20mysterious%20cosmic%20glow%2C%20deep%20navy%20blue%20and%20cyan%20accents%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20streaming%20poster%20illustration&width=600&height=900&seq=film-m011&orientation=portrait",
    category: "电视剧",
    genre: ["科幻", "悬疑", "剧情"],
    region: "中国大陆",
    year: 2023,
    director: "杨磊",
    actors: ["张鲁一", "于和伟", "陈瑾", "王子文"],
    synopsis:
      "纳米物理学家汪淼受邀调查一系列科学家离奇身亡事件，逐渐触及一个跨越四十年的谜团，以及来自宇宙深处的第一声回响。",
    rating: 8.8,
    popularity: 92,
    updateDate: "2024-07-18",
    tags: ["科幻改编", "硬核", "宇宙"],
  },
  {
    id: "m012",
    title: "县委大院",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20drama%20key%20art%2C%20an%20old%20government%20office%20building%20at%20dawn%20in%20a%20small%20Chinese%20town%2C%20warm%20morning%20light%2C%20deep%20blue%20and%20amber%20tones%2C%20realistic%20atmosphere%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20poster%20illustration&width=600&height=900&seq=film-m012&orientation=portrait",
    category: "电视剧",
    genre: ["剧情", "现实", "职场"],
    region: "中国大陆",
    year: 2022,
    director: "孔笙",
    actors: ["胡歌", "吴越", "张新成", "黄磊"],
    synopsis:
      "年轻县长梅晓歌走马上任光明县，面对重重难题，与干部同事们一道奔走在田间地头，在发展与民生之间寻找一条向上的路。",
    rating: 8.0,
    popularity: 78,
    updateDate: "2024-04-10",
    tags: ["基层", "现实主义", "群像"],
  },
  {
    id: "m013",
    title: "繁花",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20retro%20key%20art%2C%20elegant%201990s%20Shanghai%20street%20with%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20a%20stylish%20figure%20in%20a%20coat%2C%20deep%20navy%20and%20warm%20gold%20tones%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20poster%20illustration&width=600&height=900&seq=film-m013&orientation=portrait",
    category: "电视剧",
    genre: ["剧情", "年代", "都市"],
    region: "中国大陆",
    year: 2023,
    director: "王家卫",
    actors: ["胡歌", "马伊琍", "唐嫣", "辛芷蕾"],
    synopsis:
      "九十年代的上海，阿宝在时代浪潮中一路打拼成为宝总。霓虹灯下的商海沉浮与情感纠葛，交织成一幅绚烂又苍凉的年代画卷。",
    rating: 8.5,
    popularity: 91,
    updateDate: "2024-09-01",
    tags: ["上海", "九十年代", "美学"],
  },
  {
    id: "m014",
    title: "庆余年第二季",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20ancient%20costume%20fantasy%20key%20art%2C%20a%20young%20noble%20swordsman%20standing%20in%20an%20ancient%20palace%20hall%2C%20dramatic%20light%20beams%2C%20deep%20blue%20and%20gold%20tones%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20poster%20illustration&width=600&height=900&seq=film-m014&orientation=portrait",
    category: "电视剧",
    genre: ["古装", "剧情", "武侠"],
    region: "中国大陆",
    year: 2024,
    director: "孙皓",
    actors: ["张若昀", "李沁", "陈道明", "吴刚"],
    synopsis:
      "范闲“死而复生”后重返京都，在庙堂与江湖之间步步为营。身世之谜、家国之责与儿女情长交织，他必须做出属于自己的选择。",
    rating: 8.4,
    popularity: 95,
    updateDate: "2024-09-15",
    tags: ["古装权谋", "爽剧", "群像"],
    featured: true,
  },
  {
    id: "m015",
    title: "去有风的地方",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20healing%20romance%20key%20art%2C%20a%20young%20woman%20walking%20through%20a%20sunlit%20Yunnan%20village%20field%20with%20mountains%20behind%2C%20soft%20warm%20breeze%2C%20deep%20blue%20sky%20and%20warm%20green%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20poster%20illustration&width=600&height=900&seq=film-m015&orientation=portrait",
    category: "电视剧",
    genre: ["爱情", "都市", "治愈"],
    region: "中国大陆",
    year: 2023,
    director: "丁梓光",
    actors: ["刘亦菲", "李现", "胡冰卿", "牛骏峰"],
    synopsis:
      "许红豆在好友离世后独自前往云南旅居，在有风小院遇见了返乡创业的谢之遥。慢下来的日子里，她重新找回生活的节奏与勇气。",
    rating: 8.6,
    popularity: 87,
    updateDate: "2024-06-28",
    tags: ["治愈", "田园", "慢生活"],
  },
  {
    id: "m016",
    title: "隐秘的角落",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20suspense%20key%20art%2C%20three%20children%20standing%20on%20a%20seaside%20cliff%20under%20an%20overcast%20sky%2C%20dark%20moody%20atmosphere%2C%20deep%20blue%20and%20grey%20tones%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20poster%20illustration&width=600&height=900&seq=film-m016&orientation=portrait",
    category: "电视剧",
    genre: ["悬疑", "犯罪", "剧情"],
    region: "中国大陆",
    year: 2020,
    director: "辛爽",
    actors: ["秦昊", "王景春", "荣梓杉", "史彭元"],
    synopsis:
      "三个孩子在景区游玩时无意中拍下一场谋杀，一个关于秘密与成长的故事就此展开。阳光越亮，阴影越深。",
    rating: 8.9,
    popularity: 84,
    updateDate: "2024-03-22",
    tags: ["悬疑", "少年", "社会派"],
  },
  {
    id: "m017",
    title: "奔跑吧",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20energetic%20variety%20show%20key%20art%2C%20colorful%20abstract%20geometric%20stage%20background%20with%20dynamic%20light%20beams%2C%20orange%20and%20deep%20blue%20palette%2C%20joyful%20vibe%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20poster%20illustration&width=600&height=900&seq=film-m017&orientation=portrait",
    category: "综艺",
    genre: ["真人秀", "竞技", "娱乐"],
    region: "中国大陆",
    year: 2024,
    director: "节目组",
    actors: ["李晨", "郑恺", "沙溢", "白鹿"],
    synopsis:
      "跑男团再度集结，在城市与自然之间展开一场场脑力与体力的较量。欢笑、默契与团魂，让每一期都充满惊喜。",
    rating: 7.2,
    popularity: 80,
    updateDate: "2024-09-22",
    tags: ["户外竞技", "团综", "合家欢"],
  },
  {
    id: "m018",
    title: "歌手2024",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20music%20show%20key%20art%2C%20a%20concert%20stage%20with%20dramatic%20spotlight%20and%20microphone%20silhouette%2C%20deep%20navy%20and%20warm%20orange%20stage%20lighting%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20poster%20illustration&width=600&height=900&seq=film-m018&orientation=portrait",
    category: "综艺",
    genre: ["音乐", "竞技", "真人秀"],
    region: "中国大陆",
    year: 2024,
    director: "节目组",
    actors: ["那英", "孙楠", "汪苏泷", "香缇莫"],
    synopsis:
      "全开麦直播的顶级音乐竞技舞台，来自不同地区的歌手同台飙歌。每一次登台都是实力的正面较量，也是属于耳朵的盛宴。",
    rating: 7.5,
    popularity: 86,
    updateDate: "2024-09-25",
    tags: ["音乐竞技", "直播", "实力派"],
  },
  {
    id: "m019",
    title: "向往的生活",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20lifestyle%20variety%20key%20art%2C%20a%20cozy%20countryside%20cottage%20with%20a%20vegetable%20garden%20at%20golden%20hour%2C%20deep%20blue%20sky%2C%20warm%20amber%20light%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20poster%20illustration&width=600&height=900&seq=film-m019&orientation=portrait",
    category: "综艺",
    genre: ["生活", "真人秀", "治愈"],
    region: "中国大陆",
    year: 2023,
    director: "节目组",
    actors: ["何炅", "黄磊", "彭昱畅", "张子枫"],
    synopsis:
      "蘑菇屋里，主人与客人一起种地、做饭、聊天。远离喧嚣的田园时光里，藏着最简单也最动人的生活滋味。",
    rating: 7.4,
    popularity: 75,
    updateDate: "2024-05-16",
    tags: ["慢综艺", "田园", "治愈"],
  },
  {
    id: "m020",
    title: "王牌对王牌",
    cover:
      "https://readdy.ai/api/search-image?query=Fun%20variety%20show%20key%20art%2C%20vibrant%20theater%20stage%20with%20confetti%20and%20colorful%20spotlights%2C%20orange%20and%20deep%20blue%20palette%2C%20playful%20energy%2C%20no%20text%2C%20no%20letters%2C%20no%20watermark%2C%20premium%20poster%20illustration&width=600&height=900&seq=film-m020&orientation=portrait",
    category: "综艺",
    genre: ["娱乐", "游戏", "真人秀"],
    region: "中国大陆",
    year: 2024,
    director: "节目组",
    actors: ["沈腾", "贾玲", "华晨宇", "关晓彤"],
    synopsis:
      "两组明星围绕主题展开趣味比拼，情景演绎、游戏挑战轮番上演。笑点密集、惊喜不断的国民级合家欢综艺。",
    rating: 7.1,
    popularity: 72,
    updateDate: "2024-08-20",
    tags: ["合家欢", "游戏", "明星"],
  },
];

export const categoryMeta = [
  {
    key: "电影",
    title: "电影",
    subtitle: "大银幕上的光影奇观，从科幻史诗到现实题材应有尽有。",
    icon: "ri-film-line",
  },
  {
    key: "电视剧",
    title: "电视剧",
    subtitle: "长线叙事里的百态人生，悬疑、年代、都市一网打尽。",
    icon: "ri-tv-2-line",
  },
  {
    key: "综艺",
    title: "综艺",
    subtitle: "轻松欢乐的陪伴时光，音乐、竞技、生活一次看个够。",
    icon: "ri-mic-line",
  },
];

export const genreOptions = [
  "剧情",
  "科幻",
  "悬疑",
  "犯罪",
  "古装",
  "奇幻",
  "动作",
  "喜剧",
  "动画",
  "爱情",
  "年代",
  "真人秀",
  "音乐",
  "治愈",
  "竞技",
];

export const regionOptions = ["中国大陆"];

export const yearOptions = [2024, 2023, 2022, 2020, 2019];